export const tribeAccountLogin = () => {
  const $tribeAccountLogin = document.querySelector(".tribe-account-login");
  if ($tribeAccountLogin) {
    const $loginImage = $tribeAccountLogin.querySelector(
      ".tribe-account-login__image.tribe-account-login__image--login"
    );

    const $signupImage = $tribeAccountLogin.querySelector(
      ".tribe-account-login__image.tribe-account-login__image--sign-up"
    );

    const $loginWrapper = $tribeAccountLogin.querySelector(
      ".tribe-account-login__wrapper"
    );

    if ($loginWrapper) {
      const $wrapperContentsLogin = $loginWrapper.querySelector(
        ".wrapper__contents.wrapper__contents--login"
      );

      const $wrapperContentsRecover = $loginWrapper.querySelector(
        ".wrapper__contents.wrapper__contents--recover"
      );

      const $changeButtonRecover = $loginWrapper.querySelector(
        ".change__button.change__button--recover"
      );

      const $changeButtonLogin = $loginWrapper.querySelector(
        ".change__button.change__button--login"
      );

      if ($wrapperContentsLogin && $wrapperContentsRecover) {
        const showLogin = () => {
          event.preventDefault();

          $wrapperContentsRecover.classList.remove(
            "wrapper__contents--active",
            "flex"
          );
          $wrapperContentsRecover.classList.add("hidden");

          $wrapperContentsLogin.classList.add(
            "wrapper__contents--active",
            "flex"
          );
          $wrapperContentsLogin.classList.remove("hidden");

          $signupImage?.classList.remove(
            "tribe-account-login__image--active",
            "desktop:block"
          );
          $signupImage?.classList.add("desktop:hidden");
          $loginImage?.classList.add(
            "tribe-account-login__image--active",
            "desktop:block"
          );
          $loginImage?.classList.remove("desktop:hidden");
        };

        const showRecover = () => {
          $wrapperContentsLogin.classList.remove(
            "wrapper__contents--active",
            "flex"
          );
          $wrapperContentsLogin.classList.add("hidden");

          $wrapperContentsRecover.classList.add(
            "wrapper__contents--active",
            "flex"
          );
          $wrapperContentsRecover.classList.remove("hidden");

          $loginImage?.classList.remove(
            "tribe-account-login__image--active",
            "desktop:block"
          );
          $loginImage?.classList.add("desktop:hidden");

          $signupImage?.classList.add(
            "tribe-account-login__image--active",
            "desktop:block"
          );
          $signupImage?.classList.remove("desktop:hidden");
        };
        if ($changeButtonRecover) {
          $changeButtonRecover.addEventListener("click", (event) => {
            event.preventDefault();
            showRecover();
          });
        }

        if ($changeButtonLogin) {
          $changeButtonLogin.addEventListener("click", (event) => {
            event.preventDefault();
            showLogin();
          });
        }

        const url = new URL(window.location);

        if (url.hash === "#reset") {
          showRecover();
        } else if (url.hash === "#login") {
          showLogin();
        }

        const $recoverInfo =
          $wrapperContentsRecover.querySelector(".contents__info");

        const $recoverForm = $wrapperContentsRecover.querySelector(
          "form.contents__form"
        );
        const $recoverSubmitted = $wrapperContentsRecover.querySelector(
          ".contents__submitted"
        );
        const $submittedLogin =
          $recoverSubmitted.querySelector(".submitted__login");

        $submittedLogin.addEventListener("click", (event) => {
          event.preventDefault();

          showLogin();
        });

        if ($recoverForm) {
          $recoverForm.addEventListener("submit", function (e) {
            e.preventDefault();

            const $formSubmit = $recoverForm.querySelector(".form__submit");
            const originalText = $formSubmit.innerText;
            $formSubmit.disabled = true;
            $formSubmit.innerText = "Sending...";

            const formData = new FormData($recoverForm);

            fetch($recoverForm.action, {
              method: "POST",
              body: formData,
              headers: { Accept: "text/html" },
            })
              .then((response) => {
                // Check if the final URL is different from the request URL
                if (
                  response.redirected ||
                  response.url.includes("/account/login")
                ) {
                  console.log("Success: We were redirected to login.");
                }
                return response.text(); // This is the HTML of the login page
              })
              .then((responseText) => {
                console.log("responseText", responseText);
                const parser = new DOMParser();
                const doc = parser.parseFromString(responseText, "text/html");

                // Shopify usually returns errors in a div with the "errors" class
                const $newRecoverForm = doc.querySelector(
                  ".wrapper__contents.wrapper__contents--recover form.contents__form"
                );

                if ($newRecoverForm) {
                  $recoverInfo.classList.remove("flex");
                  $recoverInfo.classList.add("hidden");
                  $recoverForm.classList.add("contents__form--hidden");
                  $recoverSubmitted.classList.remove("hidden");
                  $recoverSubmitted.classList.add("flex");
                } else {
                  alert("oh dear");
                }
              })
              .catch((error) => {
                console.error("Recovery Error:", error);
                $formSubmit.disabled = false;
                $formSubmit.innerText = originalText;
              });
          });
        }
      }
    }
  }
};

export default tribeAccountLogin;
